import React, { useRef } from "react";
import { Form } from 'antd';
import { addRule } from "../../stateManagement/actions/data";
import { useDispatch } from "react-redux";
import { PROVIDERS_LIST, RULE_TYPES } from "../../utils/constants";
import BasicFormButtons from "./basicFormButtons";
import SelectableFormField from "./selectableFormField";
import InputFormField from "./inputFormField";

const NewCustomRuleForm = ({reloadData}) => {

    // Form reference for resetting
    const formRef = useRef(null);

    const dispatch = useDispatch();

    //Reset form fields
    const handleReset = () => formRef.current?.resetFields();

    // Handle form submission
    const onFinish = (values) => {
        // Dispatch action to add website
        dispatch(addRule(values));
        // Reset form and reload data
        handleReset();
        reloadData();
    };

    return(
        <Form ref={formRef} onFinish={onFinish}>
            <SelectableFormField 
                name="provider"
                label="Platform:" 
                options={PROVIDERS_LIST}
            />
            <SelectableFormField 
                name="ruleType"
                label="Type:" 
                options={RULE_TYPES}
            />
            <InputFormField label="Report value:" name="cellValue"/>
            <InputFormField label="Linked value:" name="returnedValue"/>
            <BasicFormButtons handleReset={handleReset}/>
        </Form>
    )
}

export default NewCustomRuleForm;